import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/takeUntil';
import { ClothingDisposition } from '../../models/clothing-disposition.model';
import { ClothingDispositionService } from '../../services/clothing-disposition.service';
import { ClothingDispositionModalComponent } from '../common/employee-assets/clothing-disposition-modal.component';
import { CLOTHING_DISPOSITION as C } from '../common/employee-assets/clothing-disposition.constants';
import { ASSET } from '../common/employee-assets/asset.constants';
import { assetErrorKey, workflowTrackBy } from '../common/employee-assets/asset.helpers';

interface PayrollDebt {id: string; disposition: ClothingDisposition; deduction: boolean; resume: boolean;}
@Component({selector: 'app-offboarding-payroll', template: `
  <section *ngIf="enabled && rows.length"><h4>{{ 'offboarding.payroll.debt' | translate }}</h4>
    <article *ngFor="let row of rows; trackBy: trackBy" class="offboard-item"><p>{{ row.disposition.catalogItemName || ('CLOTHES' | translate) }}<span *ngIf="row.disposition.unitNumber"> · {{ 'CLOTHING_UNIT_NUMBER' | translate }} #{{ row.disposition.unitNumber }}</span> · {{ row.disposition.amountByn }} {{ row.disposition.currency }}</p>
      <button *ngIf="row.deduction" class="btn btn-secondary" type="button" (click)="open(row.disposition, constants.deduction)">{{ 'CLOTHING_DISPOSITION_ACTION_CONFIRM_DEDUCTION' | translate }}</button>
      <button *ngIf="row.resume" class="btn btn-secondary" type="button" (click)="open(row.disposition, constants.resume)">{{ 'CLOTHING_DISPOSITION_ACTION_RESUME' | translate }}</button></article>
  </section><p *ngIf="errorKey" role="alert">{{ errorKey | translate }} <button class="btn btn-link" type="button" (click)="load()">{{ 'ASSET_RETRY' | translate }}</button></p>`,
  styleUrls: ['./offboarding-sequential.component.css', './offboarding-workspace-content.css']})
export class OffboardingPayrollComponent implements OnChanges, OnDestroy {
  @Input() employeeId: string;
  @Input() enabled = false;
  @Output() changed = new EventEmitter<void>();
  rows: PayrollDebt[] = [];
  trackBy = workflowTrackBy;
  constants = C;
  errorKey = ASSET.empty;
  private destroyed = new Subject<void>();
  private request: Subscription;
  private dialog: NgbModalRef;
  private disposed = false;
  constructor(private api: ClothingDispositionService, private modals: NgbModal) {}
  ngOnChanges(): void { this.closeDialog(); if (this.request) { this.request.unsubscribe(); } this.rows = []; if (this.enabled) { this.load(); } }
  ngOnDestroy(): void { this.disposed = true; this.closeDialog(); this.destroyed.next(); this.destroyed.complete(); }
  load(): void {
    if (this.disposed || !this.enabled) { return; }
    if (this.request) { this.request.unsubscribe(); }
    const employeeId = this.employeeId;
    this.errorKey = ASSET.empty;
    this.request = this.api.list(employeeId).takeUntil(this.destroyed).subscribe(result => {
      if (!this.enabled || this.employeeId !== employeeId) { return; }
      this.rows = result.filter(item => item.amountByn > ASSET.zero && (item.allowedActions.indexOf(C.deduction) >= ASSET.zero
        || item.allowedActions.indexOf(C.resume) >= ASSET.zero)).map(item => ({id: item.id, disposition: item,
        deduction: item.allowedActions.indexOf(C.deduction) >= ASSET.zero, resume: item.allowedActions.indexOf(C.resume) >= ASSET.zero}));
    }, error => { this.rows = []; this.errorKey = assetErrorKey(error, false); });
  }
  open(disposition: ClothingDisposition, action: string): void {
    if (this.disposed || this.dialog || !this.enabled || disposition.allowedActions.indexOf(action) < ASSET.zero) { return; }
    const ref = this.modals.open(ClothingDispositionModalComponent, {size: ASSET.modalSize, beforeDismiss: () => !ref.componentInstance.busy});
    ref.componentInstance.disposition = disposition; ref.componentInstance.action = action;
    ref.componentInstance.unit = {unitId: disposition.unitId, userId: this.employeeId, version: disposition.version, dispositionId: disposition.id};
    this.dialog = ref;
    ref.result.then(() => this.returned(ref), () => this.cancelled(ref));
  }
  private returned(ref: NgbModalRef): void { if (this.dialog !== ref) { return; } this.dialog = null; if (!this.disposed) { this.load(); this.changed.emit(); } }
  private cancelled(ref: NgbModalRef): void { if (this.dialog === ref) { this.dialog = null; } }
  private closeDialog(): void { if (this.dialog) { const ref = this.dialog; this.dialog = null; ref.close(); } }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/offboarding/offboarding-payroll.component.ts